import React, { useContext, useEffect } from 'react'
import invariant from 'tiny-invariant'
import matchPath from './matchPath'
import RouterContext from './RouterContext'

const bDebug = false

function getContext(props, context) {
  const location = props.location || context.location

  // props.computedMatch comes from <Switch>
  const match = props.computedMatch
    ? props.computedMatch
    : props.path
      ? matchPath(location.pathname, props)
      : context.match

  bDebug &&
    console.log('getContext', {
      match,
      locationPathname: location.pathname,
      props,
      propsComputedMatch: props.computedMatch,
      propsPath: props.path,
      matchPath: matchPath(location.pathname, props),
      contextMatch: context.match,
    })

  return { ...context, location, match }
}

function Route(props) {
  const context = useContext(RouterContext)

  const { component, path = '' } = props

  useEffect(() => {
    invariant(context, 'You should not use <Route> outside a <Router>')
    invariant(component, '<Route> should have component')
  }, [context, component])

  const propsWithContext = getContext(props, context)

  if (bDebug && propsWithContext.match) {
    bDebug && console.log(`XXX Route ${path}`, { t: propsWithContext.match, props, component, propsWithContext })
  } else {
    bDebug &&
      console.log(`XXX Route not match ${path}`, { t: propsWithContext.match, props, component, propsWithContext })
  }

  return (
    <RouterContext.Provider value={propsWithContext}>
      {propsWithContext.match ? component ? React.createElement(component, propsWithContext) : null : null}
    </RouterContext.Provider>
  )
}

export default Route
